import { render, staticRenderFns } from "./preloginmain.vue?vue&type=template&id=863a3038"
import script from "./preloginmain.vue?vue&type=script&lang=js"
export * from "./preloginmain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports